import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import { throwIfFailed } from "shared/dialogSubmit";
import DevOpsConnectionsStore from "./DevOpsConnectionsStore";

const devopsConnectionsRoute: RouteType[] = [
  {
    name: "DevOps Connections",
    path: "/devops/connections",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "DevOps Connections",
        enableRefreshButton: true,
        component: () => import("./DevOpsConnections.Header"),
      },
      body: {
        component: () => import("./DevOpsConnections.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    searchAliases: ["azure devops", "ado", "ado connections", "pat"],
    // Connection management (create/edit/test/remove) is admin-only — it
    // governs the single internal Azure DevOps service identity and its PAT.
    // The API enforces the admin gate on writes (reuses the organization RBAC
    // hooks); this route is admin-only so the view itself is hidden from
    // non-admins.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.devopsConnectionsViewStore as DevOpsConnectionsStore;
      store?.loadConnections();
      // Seed the global client list so the form's optional client picker has
      // options (null = the internal org).
      const clientStore = (rootStore as Record<string, unknown>).clientStore as
        | { fetchClients?: () => Promise<void>; clients?: unknown[] }
        | undefined;
      if (clientStore && !(clientStore.clients && clientStore.clients.length)) {
        clientStore.fetchClients?.();
      }
    },
    dialogs: [
      {
        name: "DevOpsConnectionFormDialog",
        title: "DevOps Connection",
        submitButtonText: "Save connection",
        component: () => import("./dialogs/DevOpsConnectionForm.Body"),
        cancelButton: true,
        height: 560,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          // A refused save throws, so the dialog stays open with the reason in
          // its footer (shared/dialogSubmit).
          const store = rootStore.devopsConnectionsViewStore as DevOpsConnectionsStore;
          throwIfFailed(await store.saveConnection(), store.formError, "The connection could not be saved.");
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.devopsConnectionsViewStore as DevOpsConnectionsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default devopsConnectionsRoute;
